<template>
    <div v-if="reviewsData && reviewsData.length" id="agent-reviews" class="agent-reviews">
        <div v-for="item in reviewsData" :key="item._id">
            <div>
                <div>
                    <b class="f4">{{item.reviewTitle}}</b>
                </div>
                <div class="agent-star">
                    <template v-for="index in 5">
                        <i class="icon-star" v-if="item.rating - index >= 0"></i>
                        <i class="icon-star-half" v-else-if="item.rating - index > -1"></i>
                        <i class="icon-star-o" v-else></i>
                    </template>
                </div>
            </div>
            <div class="text-gray f7">
                <div>
                    {{item.tip}}
                </div>
                <div>
                    {{$filters.formatDate(item.lastModifiedDateTime)}}
                </div>
            </div>
            <div>
                <div>{{item.reviewText}}</div>
            </div>
            <div v-if='item.reviewerUserId != glb.user.id'>
                <div>
                    <a class="link vote" @click="likeReview(item)" :class="{'like': item.like}">
                        <i class="icon-thumbs-up"></i> {{item.upVotes}}
                    </a>
                    <a class="link vote"  @click="dislikeReview(item)" :class="{'dislike': item.dislike}">
                        <i class="icon-thumbs-down"></i> {{item.downVotes}}
                    </a>
                </div>
                <div>
                    <a v-if="dap.evaluateReview" class="link" @click="evaluateReview(item, dap.evaluateReview)">
                         {{ item.isSpam ? dap.evaluateReview.displayOff : dap.evaluateReview.displayOn }}
                    </a>
                    <a class="link" @click="writeComment(item)">
                         Report Abuse
                    </a>
                </div>
            </div>
        </div>
        <button class="link" v-if="dap.evaluateReview" :disabled="fetchingReviews" @click="fetchMoreReviews">[ See More Reviews + ]</button>
    </div>
</template>
<script src="./agent-review.js"></script>
<style lang="scss">
@use "./agent-review.scss" as *;
</style>